import { useRef } from 'react';
import { useSponsoredWidgetTracking } from 'pathfinder/utils/sponsoredWidgets/useSponsoredWidgetTracking';
export function useHaloEffectTrack(track, id) {
    // TODO: folow-up -> https://fandom.atlassian.net/browse/ADEN-12747
    const haloEffectRef = useRef();
    const haloEffectClick = useSponsoredWidgetTracking(track, id, 'sponsored-halo-effect', haloEffectRef);
    return {
        haloEffectClick,
        haloEffectRef,
    };
}
